import { googleSearch } from './search/engines/google';
import { bingSearch } from './search/engines/bing';
import { yahooSearch } from './search/engines/yahoo';
import { lycosSearch } from './search/engines/lycos';
import { duckDuckGoSearch } from './search/engines/duckduckgo';
import { getRulesStore } from '../storage/stores';
import { getChromeStorage } from '../chrome/wrappers';
import { StoresKeys } from '../types/store';
import { buildURL } from '../helper/urlUtils';

export const engines = [
  googleSearch,
  bingSearch,
  yahooSearch,
  lycosSearch,
  duckDuckGoSearch,
] as const;

export const shouldRedirectToSafeSearch = (rawUrl: string): boolean => {
  // Should not redirect to Safe Search if feature is disabled
  if (!getRulesStore().isSafeSearch()) {
    return false;
  }

  const url = buildURL(rawUrl);
  if (!url) {
    return false;
  }

  return engines.some(
    engine => engine.isSearch(url) && !engine.isSafeSearchActive(url)
  );
};

/**
 * Return the safe URL from `rawUrl` if it's from a supported engine,
 * otherwise return `rawUrl`.
 *
 * @returns URL with safe parameters or original URL
 */
export const getSafeUrl = (rawUrl: string): string => {
  const url = buildURL(rawUrl);
  if (url !== undefined) {
    const engine = engines.find(engine => engine.isSearch(url));
    if (engine) {
      return engine.getSafeSearchUrl(url);
    }
  }

  return rawUrl;
};

export const onSafeSearchChanged = (callback: () => void) => {
  getChromeStorage().onChanged.addListener(async changes => {
    if (StoresKeys.RULES in changes) {
      const oldIsSafeSearch = changes[StoresKeys.RULES].oldValue?.isSafeSearch;
      const newIsSafeSearch = changes[StoresKeys.RULES].newValue?.isSafeSearch;
      if (oldIsSafeSearch !== newIsSafeSearch) {
        callback();
      }
    }
  });
};
